import React from 'react';
import { t } from '@sm/intl';

import usePriceDisplay from '~app/pages/Pricing/hooks/usePriceDisplay';
import { Packages } from '~shared/constants/pricing';

import FAQAnswer from '../FAQAnswer';
import COPY from './copy';
import { FAQPackagePriceProps } from './types';

const FAQPackagePrice = ({
  packageName,
  skuCosts,
  displayName,
  countryCode,
}: FAQPackagePriceProps): React.ReactElement => {
  const { isMonthlyPackage, isTeamsPackage, headerCost } = usePriceDisplay(packageName, skuCosts);

  let copyKey: keyof typeof COPY;

  if (packageName === Packages.Basic) {
    copyKey = 'FAQ_BASIC';
  } else if (isMonthlyPackage) {
    copyKey = 'FAQ_MONTHLY';
  } else if (isTeamsPackage) {
    copyKey = 'FAQ_TEAMS';
  } else {
    copyKey = 'FAQ_ANNUAL';
  }

  // Check to see if there's special copy for this country code
  const countryOverrideCopyKey = `${countryCode.toUpperCase()}_${copyKey}`;
  if (countryOverrideCopyKey in COPY) {
    copyKey = countryOverrideCopyKey as keyof typeof COPY;
  }

  return <FAQAnswer>{t(COPY[copyKey], { packageName: displayName, cost: headerCost })}</FAQAnswer>;
};

export default FAQPackagePrice;
